import React, { useEffect, useState } from "react";
import { userProfile } from "../api/Api";
import { userId, userToken } from "../../Utils/userAuth";
import "./WtPrev8.css";
import {
  FiSend,
  FiCalendar,
  FiMessageSquare,
  FiFileText,
  FiClock,
  FiUserCheck,
} from "react-icons/fi";

const WtPrev8 = (props) => {
  const [inputVal, setInputVal] = useState("");
  const [parent_id, setParent_id] = useState(null);
  const [parentType, setParentType] = useState(null);
  const [brandName, setBrandName] = useState("");

  useEffect(() => {
    const siteSettings = localStorage.getItem("siteSettings");
    if (siteSettings) {
      const parsed = JSON.parse(siteSettings);
      setBrandName(parsed.brand_name || "");
    }
  }, []);

  useEffect(() => {
    const storedLogin = localStorage.getItem("login");
    if (storedLogin) {
      const parsed = JSON.parse(storedLogin);
      setParentType(parsed?.user?.parent_type || null);
    }

    const paramData = {
      user_id: userId,
      token: userToken,
      method: "retrieve",
    };

    userProfile(paramData).then((result) => {
      if (result.data.success === true) {
        setParent_id(result.data.data[0].parent);
      }
    });
  }, []);

  const toggleWidget = () => {
    const td = document.getElementById("authkey-tgl");
    if (!td) return;
    td.classList.toggle("authkey-ds8");
    td.classList.toggle("authkey-dh8");
  };

  const closeWidget = () => {
    const td = document.getElementById("authkey-tgl");
    if (!td) return;
    td.classList.remove("authkey-ds8");
    td.classList.add("authkey-dh8");
  };

  const sendMessage = () => {
    const encodedText = encodeURIComponent(inputVal);
    const url = `https://wa.me/${props.mobile_no}?text=${encodedText}`;
    window.open(url, "_blank");
  };

  return (
    <div>
      <div
        className="wt3-wrapper8"
        style={{
          [props.position]: `${props.sidemargin}px`,
          bottom: `${props.marginbottom}px`,
        }}
      >
        {/* Widget Card */}
        <div
          id="authkey-tgl"
          className={`wt3-card8 ${props.wtstatus === "yes" ? "authkey-ds8" : "authkey-dh8"
            }`}
        >
          <div className="wt3-card-inner8">
            {/* Header */}
            <div className="wt3-header8"
              style={{
                background:
                  props.bgcolor || "linear-gradient(180deg,#0fa054,#0da34b)",
              }}
            >
              <div className="wt3-avatar-area8">
                <div className="wt3-avatar8">
                  <img
                    src={props.logourl}
                    alt="avatar"
                    className="wt3-avatar-img8"
                    style={{ width: "100%", height: "100%" }}
                  />
                  <span className="wt3-avatar-online8" />
                </div>
              </div>

              <div className="wt3-title-area8">
                <div className="wt3-title8">
                  {props.displayname || "Dr. Sarah Williams"}
                </div>
                <div className="wt3-subtitle8">
                  {props.subtitle || "General Practitioner"}
                </div>
              </div>

              <button className="wt3-close8" onClick={closeWidget} aria-label="close">
                ×
              </button>
            </div>

            {/* Body */}
            <div className="wt3-body8">
              {/* Info Section 1 */}
              <div className="wt3-info-card8">
                <div className="wt3-info-text8">Medical Consultation Available</div>
                <ul className="wt3-features8">
                  <li>
                    <span className="wt3-feature-icon8"><FiCalendar /></span>
                    <span>Book appointments</span>
                  </li>
                  <li>
                    <span className="wt3-feature-icon8"><FiMessageSquare /></span>
                    <span>Ask medical questions</span>
                  </li>
                  <li>
                    <span className="wt3-feature-icon8"><FiFileText /></span>
                    <span>Get prescription refills</span>
                  </li>
                </ul>
              </div>

              {/* Info Section 2 */}
              <div className="wt3-response8">
                <div className="wt3-response-label8">Patient Care Hours</div>
                <div className="wt3-response-time8">
                  Mon–Fri: 8 AM – 8 PM
                  <br />
                  Emergency? Call 911
                </div>
              </div>

              {/* Input */}
              <div className="wt3-input-row8">
                <input
                  id="authkey-message-input8"
                  className="wt3-input8"
                  placeholder="Type your text..."
                  value={inputVal}
                  onChange={(e) => setInputVal(e.target.value)}
                />
                <button
                  className="wt3-send8"
                  onClick={sendMessage}
                  aria-label="send"
                >
                  <FiSend />
                </button>
              </div>

              {/* Footer */}
              {!props.removeBranding && (
              <div className="wt3-footer8" style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                textAlign: "center",
              }}>
                <p className="wt3-brand8">
                  Powered by{" "}
                  <a
                    href="https://authkey.io"
                    target="_blank"
                    rel="noreferrer"
                    className="wt3-link"
                  >
                    Authkey.io
                  </a>
                </p>
              </div>
              )}
            </div>
          </div>
        </div>

        {/* Floating Button */}
        <button
          className="wt3-float-btn8"
          id="authkey-wt-btn"
          onClick={toggleWidget}
          aria-label="open chat"
        >
          <FiUserCheck className="wt3-cart-icon8" />
          <span class="wt3-badge8"></span>

        </button>
      </div>
    </div>
  );
};

export default WtPrev8;
